/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Reset_Password_SuccessInputs */

const en_common_sign_reset_password_success = /** @type {(inputs: Common_Sign_Reset_Password_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your password has been reset. You can now sign in.`)
};

const zh_common_sign_reset_password_success = /** @type {(inputs: Common_Sign_Reset_Password_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码已重置，请使用新密码登录。`)
};

/**
* | output |
* | --- |
* | "Your password has been reset. You can now sign in." |
*
* @param {Common_Sign_Reset_Password_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_reset_password_success = /** @type {((inputs?: Common_Sign_Reset_Password_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Reset_Password_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_reset_password_success(inputs)
	return zh_common_sign_reset_password_success(inputs)
});
export { common_sign_reset_password_success as "common.sign.reset_password_success" }